import * as yup from "yup";
const schema = yup.object().shape({
    name: yup.string().required("ПІБ пацієнта обов'язкове"),
    gender: yup.string().required("Стать обов'язкова"),
    dateOfBirth: yup.string().required("Дата народження обов'язкова"),
    email: yup.string().email("Невірний формат введення пошти").optional(),
    primaryPhone: yup
        .string()
        .required("Номер телефону обов'язковий")
        .matches(
            /\+[0-9]{2,3}[0-9]{2,3}[0-9]{2,3}[0-9]{2}[0-9]{2}[0-9]{2}/gi,
            "Невірний формат номеру",
        )
        .max(18, "Номер телефону занадто довгий"),
    primaryPhoneName: yup.string().optional(),
    adress: yup.string().optional(),

    secondaryPhones: yup.array().of(
        yup.object().shape({
            type: yup
                .string()
                .required("Тип додаткового телефону обов'язковий"),
            number: yup
                .string()
                .required("Номер додаткового телефону обов'язковий")
                .matches(
                    /\+[0-9]{2,3}[0-9]{2,3}[0-9]{2,3}[0-9]{2}[0-9]{2}[0-9]{2}/gi,
                    "Невірний формат номеру",
                ),
            _id: yup.string().optional(),
        }),
    ),
    dentalFormulas: yup.array().optional(),
    patientPhotos: yup
        .array()
        .of(
            yup.object().shape({
                patientId: yup.string().required(),
                title: yup.string().required(),
                _id: yup.string().required(),
                description: yup.string().required(),
                filePath: yup.array().of(yup.string().required()).required(),
                uploadedAt: yup.string().required(),
            }),
        )
        .required(),
    _id: yup.string().optional(),
});
export default schema;
